import {useQuery} from 'react-query'

import {routeTo} from '@/utils/router'
import {LogoEntityType} from '@/utils/user-portal/types'

type EntityImageData = {
  id: number
  name: string
  url: string
}

const endpointMap: Record<LogoEntityType, (id: any) => string> = {
  [LogoEntityType.RegistrationRequest]: routeTo.api.request.logoUrl,
  [LogoEntityType.Trademark]: routeTo.api.trademark.logoUrl,
  [LogoEntityType.ExternalTrademark]: routeTo.api.externalTrademark.logoUrl,
}
export const useEntityLogo = (
  logoEntityType: LogoEntityType,
  entityId?: string | null,
  enabled = true,
) =>
  useQuery({
    queryKey: ['entityLogo', logoEntityType, entityId],
    queryFn: async ({signal}): Promise<EntityImageData[] | undefined> => {
      const response = await fetch(endpointMap[logoEntityType](entityId), {signal})
      if (response.ok) {
        return await response.json()
      } else {
        return undefined
      }
    },
    staleTime: 172_800_000, //2 days in ms
    enabled: Boolean(entityId) && enabled,
  })
